<template>
    <div>
        <div style="margin-top: 100px">
            <h2 style="text-align: center">{{new Date().getFullYear()}}年湖北省普通高等学校专升本考生疫情相关情况登记表<span style="color: red">(同一天提交多次将取最后一次)</span></h2>
            <el-form  :model="upsertForm"  :rules="rules" label-position="top"  ref="upsertForm" label-width="100px" style="margin-top: 20px;padding-bottom: 20px;padding-left: 20px" :inline="true"  :closable="false">
                <div style="width: 100%;" class="longItemLable">
                    <el-form-item label="现身处地详细地址（X省X市X县/区X村/楼盘X栋X号）" prop="currentAddress">
                        <el-input size="mini" maxlength="255" show-word-limit style="width: 450px;" v-model="upsertForm.currentAddress" placeholder="请输入现身处地详细地址（X省X市X县/区X村/楼盘X栋X号）" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="现是否处于中高风险地区（是/否）" prop="highRiskStaus">
                        <el-input size="mini" maxlength="20" show-word-limit  style="width: 450px;" v-model="upsertForm.highRiskStaus" placeholder="请输入现是否处于中高风险地区（是/否）" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="身处风险地区名称（与疫情风险等级查询所列名称一致，X省X市X县/区X村/楼盘X栋X号/无）" prop="highRiskAddress">
                        <el-input size="mini" maxlength="255" show-word-limit  style="width: 450px;" v-model="upsertForm.highRiskAddress" placeholder="请输入身处风险地区名称（与疫情风险等级查询所列名称一致）" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="隔离情况（居家隔离/集中隔离/小区封控/无）" prop="isolation">
                        <el-input size="mini" maxlength="255" show-word-limit  style="width: 450px;" v-model="upsertForm.isolation" placeholder="请输入隔离情况（居家隔离/集中隔离/小区封控）" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="隔离/封控起止时间（mm月dd日-mm月dd日/无）" prop="isolationTime">
                        <el-input size="mini" maxlength="100" show-word-limit  style="width: 450px;" v-model="upsertForm.isolationTime" placeholder="请输入隔离/封控起止时间（mm月dd日-mm月dd日/无）" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="预估能否参加现场考试（能参考/不能参考/不确定）" prop="examStatus">
                        <el-input size="mini" maxlength="100" show-word-limit  style="width: 450px;" v-model="upsertForm.examStatus" placeholder="请输入预估能否参加现场考试（能参考/不能参考/不确定）" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <div>
                    <el-button size="mini"  type="primary" @click="saveOrUpdate('upsertForm')" style="width: 100%;">提交</el-button>
                </div>
                <div style="margin-top: 10px">
                    <el-button size="mini"  type="danger" @click="clear" style="width: 100%;">清空</el-button>
                </div>
                <div style="margin-top: 10px">
                    <el-button size="mini"  type="success" @click="submit" style="width: 100%;">刷新</el-button>
                </div>
            </div>
        </div>
        <div>
            <h2 style="text-align: center">填报情况</h2>
            <el-row :gutter="24">
                <el-col :span="4" v-for="item in tableData">
                    <el-card shadow="always" >
                        <el-button type="text" size="mini" @click="findInfoById(item.id)">{{item.dayTime}}已填报</el-button>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'sysStudentSituationInfo',
        data() {
            return {
                upsertForm:{
                    id:'',
                    studentId:'',
                    studentName:'',
                    idCard:'',
                    currentAddress:'',
                    highRiskStaus:'',
                    highRiskAddress:'',
                    isolation:'',
                    isolationTime:'',
                    examStatus:'',
                    dayTime:'',
                    updateTime:'',
                    createTime:''
                },
                rules: {
                    studentId: [
                        { required: true, message: '请输入学生编号', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    studentName: [
                        { required: true, message: '请输入学生姓名', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    idCard: [
                        { required: true, message: '请输入身份证号', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    currentAddress: [
                        { required: true, message: '请输入现身处地详细地址', trigger: 'blur' },
                        {  max: 255, message: '长度必须少于255个字符', trigger: 'blur' }
                    ],
                    highRiskStaus: [
                        { required: true, message: '请输入现是否处于中高风险地区', trigger: 'blur' },
                        {  max: 20, message: '长度必须少于20个字符', trigger: 'blur' }
                    ],
                    highRiskAddress: [
                        { required: true, message: '请输入身处风险地区名称', trigger: 'blur' },
                        {  max: 255, message: '长度必须少于255个字符', trigger: 'blur' }
                    ],
                    isolation: [
                        { required: true, message: '请输入隔离情况', trigger: 'blur' },
                        {  max: 100, message: '长度必须少于100个字符', trigger: 'blur' }
                    ],
                    isolationTime: [
                        { required: true, message: '请输入隔离/封控起止时间', trigger: 'blur' },
                        {  max: 100, message: '长度必须少于100个字符', trigger: 'blur' }
                    ],
                    examStatus: [
                        { required: true, message: '请输入预估能否参加现场考试', trigger: 'blur' },
                        {  max: 100, message: '长度必须少于100个字符', trigger: 'blur' }
                    ],
                    dayTime: [
                        { required: true, message: '请输入填报日期', trigger: 'blur' },
                    ],
                    updateTime: [
                        { required: true, message: '请输入修改时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                    createTime: [
                        { required: true, message: '请输入创建时间', trigger: 'blur' },
                        {  max: 32, message: '长度必须少于32个字符', trigger: 'blur' }
                    ],
                },
                tableData:[],
            }
        },
        created() {
            this.submit();
        },
        mounted() {
        },
        methods: {
            submit(){
                axios({
                    url:`${home}/sysStudentSituation/findSysStudentSituationsByMyId`,
                    method:'GET',
                }).then(res=>{
                    this.tableData=res.data;
                }).catch(function (error) {
                    console.log(error);
                });
            },
            clear(){
                this.$refs['upsertForm'].resetFields();
            },
            saveOrUpdate(formName){
                this.$refs[formName].validate(valid=>{
                    if(valid){
                        axios({
                            url:`${home}/sysStudentSituation/saveSysStudentSituation`,
                            method:'POST',
                            data:this.upsertForm
                        }).then(res=>{
                            this.$message({
                                message: '登记成功',
                                type: 'success'
                            });
                            this.$refs[formName].resetFields();
                            this.submit();
                        }).catch(error=>{
                            //do something
                        })


                    }
                })
            },
            findInfoById(id){
                axios({
                    url:`${home}/sysStudentSituation/look/lookSysStudentSituationById/${id}`,
                    method:'GET'
                }).then(res=>{
                    Object.assign(this.upsertForm,res.data);
                }).catch(error=>{
                    console.log(error);
                })
            }
        }
    }
</script>

<style scoped>

</style>